export const FILIAL_SERVICE_GET_REQUEST = 'FILIAL_SERVICE_GET_REQUEST';
export const FILIAL_SERVICE_GET_SUCCESS = 'FILIAL_SERVICE_GET_SUCCESS';
export const FILIAL_SERVICE_GET_ERROR = 'FILIAL_SERVICE_GET_ERROR';
export const FILIAL_SERVICE_GET_BY_KEY_REQUEST = 'FILIAL_SERVICE_GET_BY_KEY_REQUEST';
export const FILIAL_SERVICE_GET_BY_KEY_SUCCESS = 'FILIAL_SERVICE_GET_BY_KEY_SUCCESS';
export const FILIAL_SERVICE_GET_BY_KEY_ERROR = 'FILIAL_SERVICE_GET_BY_KEY_ERROR';
export const FILIAL_SERVICE_ADD_REQUEST = 'FILIAL_SERVICE_ADD_REQUEST';
export const FILIAL_SERVICE_ADD_SUCCESS = 'FILIAL_SERVICE_ADD_SUCCESS';
export const FILIAL_SERVICE_ADD_ERROR = 'FILIAL_SERVICE_ADD_ERROR';
export const FILIAL_SERVICE_EDIT_REQUEST = 'FILIAL_SERVICE_EDIT_REQUEST';
export const FILIAL_SERVICE_EDIT_SUCCESS = 'FILIAL_SERVICE_EDIT_SUCCESS';
export const FILIAL_SERVICE_EDIT_ERROR = 'FILIAL_SERVICE_EDIT_ERROR';
export const FILIAL_SERVICE_DELETE_REQUEST = 'FILIAL_SERVICE_DELETE_REQUEST';
export const FILIAL_SERVICE_DELETE_SUCCESS = 'FILIAL_SERVICE_DELETE_SUCCESS';
export const FILIAL_SERVICE_DELETE_ERROR = 'FILIAL_SERVICE_DELETE_ERROR';
